export default __webpack_public_path__ + "static/9_23-fc01f8215f2590a02ca02274d7c11afd.png";